module.exports = __webpack_public_path__ + "static/load-chart-0321969a86b6e6b384198f0709fdf078.png";